import { render, staticRenderFns } from "./NotificationHeader.vue?vue&type=template&id=00c02b9b&scoped=true&"
import script from "./NotificationHeader.vue?vue&type=script&lang=js&"
export * from "./NotificationHeader.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHeader.vue?vue&type=style&index=0&id=00c02b9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c02b9b",
  null
  
)

export default component.exports